import { render, staticRenderFns } from "./GiftCardVisualSettings.vue?vue&type=template&id=2d2b83a2&"
import script from "./GiftCardVisualSettings.vue?vue&type=script&lang=ts&"
export * from "./GiftCardVisualSettings.vue?vue&type=script&lang=ts&"
import style0 from "./GiftCardVisualSettings.vue?vue&type=style&index=0&id=2d2b83a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports